<template>
  <div>
    <div class="module-title">资质证书</div>
    <div class="horner-content">
      <div
        class="horner-list"
        v-for="(item, index) in dataList"
        :key="index"
        @click="showImg(item)"
      >
        <img class="team-img" :src="application.imageHost + item.imagePath" />
      </div>
    </div>
    <preImg :imgSrc="imgSrc" v-if="isShow" @hideImg="hideImg"></preImg>
  </div>
</template>
<style src="./horner.css" scoped></style>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import preImg from "../preview/preview.vue";
import mixins from "../../common/mixin";
import application from "../../common/application";
export default {
  name: "companyIntro",
  components: {
    swiper,
    swiperSlide,
    preImg,
  },
  data: () => ({
    dataList: [],
    imgSrc: "",
    isShow: false,
    application: application,
  }),
  mixins: [mixins],
  created() {
    this.getData();
  },
  methods: {
    hideImg() {
      this.isShow = false;
    },
    // 预览
    showImg(item) {
      this.isShow = true;
      this.imgSrc = this.application.imageHost + item.imagePath;
    },
    //获取数据
    getData() {
      let data = {
        pageIndex: 0,
        pageSize: 30,
      };
      this.request({
        url: "/web/introduce/honor",
        data: data,
        success: (response) => {
          this.dataList = response.data.records;
          // console.log(this.bannerList)
        },
        error: (response) => {
          this.$Message.error(response.message);
        },
        complete: () => {},
      });
    },
  },
};
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/components/horner/horner.vue